import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { calculateValues } from 'components/modules/EditHarvestSummaryModal/utils';
import { ItemDetailsRow } from '../../assets';
import ItemDetailTableHeadRow from '../../assets/ItemDetailTableHeadRow';

// Create styles
const styles = StyleSheet.create({
  itemDetails: {
    width: 547, // Fit within page padding (595 - 24*2)
    backgroundColor: '#FFFCE8',
    borderRadius: 12,
    marginBottom: 10, // Further reduced to give maximum space for footer
  },
  impactTextTitileBtm: {
    color: '#53575A',
    fontFamily: 'Trebuchet',
    fontSize: 16,
    fontStyle: 'normal',
    fontWeight: 'bold',
    lineHeight: 'normal',
  },
  textTitle: {
    padding: '16px 24px',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
  },
  itemTableContainer: {
    position: 'relative',
  },
  absCards: {
    position: 'absolute',
    bottom: -10, // Move 10px lower than bottom edge
    color: '#C96974',
    fontFamily: 'Trebuchet',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: 10,
    width: 105,
    height: 25,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#FFFCE8',
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },
  deliveries: {
    left: 76,
  },
  pickups: {
    left: 223,
  },
  bottomRound: {
    borderBottomLeftRadius: 6,
    borderBottomRightRadius: 6,
    overflow: 'hidden',
  },
});
type PdfHarvestSummaryReportProps = {
  reportData: any;
};

// Create Document Component
const ItemDetails = ({ reportData }: PdfHarvestSummaryReportProps) => {
  // Sort the details array
  const details = React.useMemo(() => {
    if (!reportData?.details) return [];

    return [...reportData.details].sort((a: any, b: any) => {
      // Priority sort if available, else natural alphanumeric by name
      const priorityA = a?.sku?.priority ?? Number.POSITIVE_INFINITY;
      const priorityB = b?.sku?.priority ?? Number.POSITIVE_INFINITY;
      if (priorityA !== priorityB) return priorityA - priorityB;
      const nameA = a?.sku?.name ?? '';
      const nameB = b?.sku?.name ?? '';
      return String(nameA).localeCompare(String(nameB), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    });
  }, [reportData?.details]);
  const values = calculateValues(details);

  return (
    <View style={styles.itemTableContainer}>
      <View style={styles.itemDetails}>
        <View style={styles.textTitle}>
          <Text style={styles.impactTextTitileBtm}>Item Details</Text>
        </View>
        <View>
          <View style={{ padding: 8 }}>
            <View style={styles.bottomRound}>
              <ItemDetailTableHeadRow />
              {details.map((item: any, index: number) => {
                return (
                  <ItemDetailsRow
                    key={index}
                    isOdd={index % 2 === 0}
                    row={item}
                  />
                );
              })}
              <ItemDetailsRow isTotal row={values} />
            </View>
          </View>
        </View>
      </View>
      <View style={{ ...styles.absCards, ...styles.deliveries }}>
        <Text>
          {reportData?.totalOrders}{' '}
          {(reportData?.totalOrders || 0) > 1 ? 'Deliveries' : 'Delivery'}
        </Text>
      </View>
      <View style={{ ...styles.absCards, ...styles.pickups }}>
        <Text>
          {' '}
          {reportData?.totalPickups}{' '}
          {(reportData?.totalPickups || 0) > 1 ? 'Pickups' : 'Pickup'}
        </Text>
      </View>
    </View>
  );
};

export default ItemDetails;
